import {FeaturedProductKey} from '../../shared/enums/featured-product-key.enum';
import {RuntimeEnvironment} from '../../shared/enums/runtime-environment.enum';
import {
    FeaturedProductEndpoint,
    FeaturedProductEnvEndpoint,
    FeaturedProductIconConfig,
    FeaturedProductTileConfig,
    FeaturedProductUrlParamConfig
} from '../../shared/models/featured-product';
import {BusinessParamName} from '../../shared/models/request-offer/request-offer.enum';
import {QueryParamName} from '../enums/query-param-name.enum';
import {SalesChannel} from '../consts/sales-channel.enum';
import {isNestBank} from '../utils/utils';

export class FeaturedProductsConfig {

    private readonly ENDPOINTS: FeaturedProductEndpoint[] = [
        {
            key: FeaturedProductKey.TRAVEL,
            endpoints: [
                {
                    env: RuntimeEnvironment.DEV,
                    urls: [
                        {
                            salesChannel: SalesChannel.KIOSKPOLIS,
                            default: true,
                            url: 'https://test.kioskpolis.pl/kalkulator/ubezpieczenie-turystyczne/web/'
                        },
                        {
                            salesChannel: SalesChannel.NESTBANK,
                            url: 'https://test-nestbank.kioskpolis.pl/ubezpieczenie-turystyczne/'
                        }
                    ]
                },
                {
                    env: RuntimeEnvironment.TEST,
                    urls: [
                        {
                            salesChannel: SalesChannel.KIOSKPOLIS,
                            default: true,
                            url: 'https://test.kioskpolis.pl/kalkulator/ubezpieczenie-turystyczne/web/'
                        },
                        {
                            salesChannel: SalesChannel.NESTBANK,
                            url: 'https://test-nestbank.kioskpolis.pl/ubezpieczenie-turystyczne/'
                        }
                    ]
                },
                {
                    env: RuntimeEnvironment.PROD,
                    urls: [
                        {
                            salesChannel: SalesChannel.KIOSKPOLIS,
                            default: true,
                            url: 'https://kioskpolis.pl/kalkulator/ubezpieczenie-turystyczne/web/'
                        },
                        {
                            salesChannel: SalesChannel.NESTBANK,
                            url: 'https://nestbank.kioskpolis.pl/ubezpieczenie-turystyczne/'
                        }
                    ]
                }
            ]
        },
        {
            key: FeaturedProductKey.MOTO,
            endpoints: [
                {
                    env: RuntimeEnvironment.DEV,
                    urls: [
                        {
                            salesChannel: SalesChannel.KIOSKPOLIS,
                            default: true,
                            url: 'https://dev.kioskpolis.pl/ubezpieczenie-samochodu/kalkulator-oc-ac/'
                        }
                    ]
                },
                {
                    env: RuntimeEnvironment.TEST,
                    urls: [
                        {
                            salesChannel: SalesChannel.KIOSKPOLIS,
                            default: true,
                            url: 'https://test.kioskpolis.pl/ubezpieczenie-samochodu/kalkulator-oc-ac/'
                        }
                    ]
                },
                {
                    env: RuntimeEnvironment.PROD,
                    urls: [
                        {
                            salesChannel: SalesChannel.KIOSKPOLIS,
                            default: true,
                            url: 'https://kioskpolis.pl/ubezpieczenie-samochodu/kalkulator-oc-ac/'
                        }
                    ]
                }
            ]
        },
        {
            key: FeaturedProductKey.CAR,
            endpoints: [
                {
                    env: RuntimeEnvironment.DEV,
                    urls: [
                        {
                            salesChannel: SalesChannel.KIOSKPOLIS,
                            default: true,
                            url: 'https://test.kioskpolis.pl/ubezpieczenie-assistance/'
                        }
                    ]
                },
                {
                    env: RuntimeEnvironment.TEST,
                    urls: [
                        {
                            salesChannel: SalesChannel.KIOSKPOLIS,
                            default: true,
                            url: 'https://test.kioskpolis.pl/ubezpieczenie-assistance/'
                        }
                    ]
                },
                {
                    env: RuntimeEnvironment.PROD,
                    urls: [
                        {
                            salesChannel: SalesChannel.KIOSKPOLIS,
                            default: true,
                            url: 'https://kioskpolis.pl/ubezpieczenie-assistance/'
                        }
                    ]
                }
            ]
        },
        {
            key: FeaturedProductKey.CDW,
            endpoints: [
                {
                    env: RuntimeEnvironment.DEV,
                    urls: [
                        {
                            salesChannel: SalesChannel.KIOSKPOLIS,
                            default: true,
                            url: 'https://dev.kioskpolis.pl/kalkulator-udzial-wlasny-wynajem-auta/'
                        }
                    ]
                },
                {
                    env: RuntimeEnvironment.TEST,
                    urls: [
                        {
                            salesChannel: SalesChannel.KIOSKPOLIS,
                            default: true,
                            url: 'https://test.kioskpolis.pl/kalkulator-udzial-wlasny-wynajem-auta/'
                        }
                    ]
                },
                {
                    env: RuntimeEnvironment.PROD,
                    urls: [
                        {
                            salesChannel: SalesChannel.KIOSKPOLIS,
                            default: true,
                            url: 'https://kioskpolis.pl/kalkulator-udzial-wlasny-wynajem-auta/'
                        }
                    ]
                }
            ]
        },
        {
            key: FeaturedProductKey.TRAVEL_CANCELLATION,
            endpoints: [
                {
                    env: RuntimeEnvironment.DEV,
                    urls: [
                        {
                            salesChannel: SalesChannel.KIOSKPOLIS,
                            default: true,
                            url: 'https://test.kioskpolis.pl/ubezpieczenie-kosztow-rezygnacji/'
                        },
                        {
                            salesChannel: SalesChannel.NESTBANK,
                            url: 'https://test-nestbank.kioskpolis.pl/ubezpieczenie-kosztow-rezygnacji/'
                        }
                    ]
                },
                {
                    env: RuntimeEnvironment.TEST,
                    urls: [
                        {
                            salesChannel: SalesChannel.KIOSKPOLIS,
                            default: true,
                            url: 'https://test.kioskpolis.pl/ubezpieczenie-kosztow-rezygnacji/'
                        },
                        {
                            salesChannel: SalesChannel.NESTBANK,
                            url: 'https://test-nestbank.kioskpolis.pl/ubezpieczenie-kosztow-rezygnacji/'
                        }
                    ]
                },
                {
                    env: RuntimeEnvironment.PROD,
                    urls: [
                        {
                            salesChannel: SalesChannel.KIOSKPOLIS,
                            default: true,
                            url: 'https://kioskpolis.pl/ubezpieczenie-kosztow-rezygnacji/'
                        },
                        {
                            salesChannel: SalesChannel.NESTBANK,
                            url: 'https://nestbank.kioskpolis.pl/ubezpieczenie-kosztow-rezygnacji/'
                        }
                    ]
                }
            ]
        }
    ]

    createTilesConfig(): FeaturedProductTileConfig[] {
        return [
            {
                key: FeaturedProductKey.TRAVEL_CANCELLATION,
                header: 'FEATURED_PRODUCTS.TRAVEL_CANCELLATION.TILE.HEADER',
                name: 'FEATURED_PRODUCTS.TRAVEL_CANCELLATION.TILE.NAME',
                endpoints: this.getEndpoints(FeaturedProductKey.TRAVEL_CANCELLATION),
                imageSrc: './assets/images/featured-products/travel-cancellation-nestbank.png',
                features: [
                    'FEATURED_PRODUCTS.TRAVEL_CANCELLATION.TILE.FEATURES.FEATURE_1',
                    'FEATURED_PRODUCTS.TRAVEL_CANCELLATION.TILE.FEATURES.FEATURE_2',
                    'FEATURED_PRODUCTS.TRAVEL_CANCELLATION.TILE.FEATURES.FEATURE_3',
                ],
                disabled: !isNestBank()
            },
            {
                key: FeaturedProductKey.TRAVEL,
                header: 'FEATURED_PRODUCTS.TRAVEL.TILE.HEADER',
                name: 'FEATURED_PRODUCTS.TRAVEL.TILE.NAME',
                endpoints: this.getEndpoints(FeaturedProductKey.TRAVEL),
                imageSrc: isNestBank() ? './assets/images/featured-products/travel-nestbank.png' : './assets/images/featured-products/travel.svg',
                features: [
                    'FEATURED_PRODUCTS.TRAVEL.TILE.FEATURES.FEATURE_1',
                    'FEATURED_PRODUCTS.TRAVEL.TILE.FEATURES.FEATURE_2',
                    'FEATURED_PRODUCTS.TRAVEL.TILE.FEATURES.FEATURE_3',
                ]
            },
            {
                key: FeaturedProductKey.CAR,
                header: 'FEATURED_PRODUCTS.CAR.TILE.HEADER',
                name: 'FEATURED_PRODUCTS.CAR.TILE.NAME',
                endpoints: this.getEndpoints(FeaturedProductKey.CAR),
                imageSrc: './assets/images/featured-products/car.svg',
                features: [
                    'FEATURED_PRODUCTS.CAR.TILE.FEATURES.FEATURE_1',
                    'FEATURED_PRODUCTS.CAR.TILE.FEATURES.FEATURE_2',
                    'FEATURED_PRODUCTS.CAR.TILE.FEATURES.FEATURE_3',
                ],
                disabled: isNestBank()
            }
        ];
    }

    createIconsConfig(): FeaturedProductIconConfig[] {
        return [
            {
                key: FeaturedProductKey.MOTO,
                name: 'FEATURED_PRODUCTS.MOTO.ICON.NAME',
                iconSrc: './assets/images/featured-products/moto-icon.svg',
                endpoints: this.getEndpoints(FeaturedProductKey.MOTO)
            },
            {
                key: FeaturedProductKey.CAR,
                name: 'FEATURED_PRODUCTS.CAR.ICON.NAME',
                iconSrc: './assets/images/featured-products/car-icon.svg',
                endpoints: this.getEndpoints(FeaturedProductKey.CAR)
            },
            {
                key: FeaturedProductKey.TRAVEL,
                name: 'FEATURED_PRODUCTS.TRAVEL.ICON.NAME',
                iconSrc: './assets/images/featured-products/travel-icon.svg',
                endpoints: this.getEndpoints(FeaturedProductKey.TRAVEL)
            },
            {
                key: FeaturedProductKey.TRAVEL_CANCELLATION,
                name: 'FEATURED_PRODUCTS.TRAVEL_CANCELLATION.ICON.NAME',
                iconSrc: './assets/images/featured-products/travel-cancellation-icon.svg',
                endpoints: this.getEndpoints(FeaturedProductKey.TRAVEL_CANCELLATION)
            },
            {
                key: FeaturedProductKey.CDW,
                name: 'FEATURED_PRODUCTS.CDW.ICON.NAME',
                iconSrc: './assets/images/featured-products/cdw-icon.svg',
                endpoints: this.getEndpoints(FeaturedProductKey.CDW)
            },
        ];
    }

    createUrlParamsConfig(): FeaturedProductUrlParamConfig[] {
        return [
            {
                paramName: QueryParamName.CONTEXT,
                businessParamName: BusinessParamName.APPLICATION_CONTEXT
            },
            {
                paramName: QueryParamName.PARTNER,
                businessParamName: BusinessParamName.PARTNER_SHORT_NAME
            },
            {
                paramName: QueryParamName.PARTNER_ID,
                businessParamName: BusinessParamName.PORTAL_PARTNER_ID
            },
            {
                paramName: QueryParamName.USER_ID,
                businessParamName: BusinessParamName.PORTAL_USER_ID
            },
            {
                paramName: QueryParamName.APPLICATION_ID,
                businessParamName: BusinessParamName.APPLICATION_ID
            },
            {
                paramName: QueryParamName.SOURCE,
                staticValue: 'moto_thank_you_page'
            }
        ];
    }

    private getEndpoints(key: FeaturedProductKey): FeaturedProductEnvEndpoint[] {
        const endpointsItem = this.ENDPOINTS.find(config => config.key === key);
        return endpointsItem ? endpointsItem.endpoints : [];
    }
}
